import React, { useEffect } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { Editor } from 'pandadoc-editor';

interface IPandaDocEditor {
  pandaDocTemplateId: string;
  token: string;
  editingSessionId: string;
}

export const PandaDocEditor: React.FC<IPandaDocEditor> = ({
  pandaDocTemplateId,
  token,
  editingSessionId
}) => {
  const isAbove1660 = useMediaQuery('(min-width:1660px)');
  const isAbove960 = useMediaQuery('(min-width:960px)');

  useEffect(() => {
    let width = 400;
    let height = 800;

    if (isAbove1660) {
      width = 1000;
    } else if (isAbove960) {
      width = 650;
    }

    const editor = new Editor(
      `editor-container-${editingSessionId}`,
      {
        fieldPlacementOnly: false,
        width,
        height,
        token
      },
      null
    );
    editor.open();
  }, [pandaDocTemplateId, token, isAbove1660, isAbove960, editingSessionId]);

  return <Box key={token} id={`editor-container-${editingSessionId}`} sx={{ width: '100%' }} />;
};
